import { createContext, useContext, useState } from 'react';

const NotesContext = createContext();

export const useNotes = () => useContext(NotesContext);

export const NotesProvider = ({ children }) => {
  const [showNotes, setShowNotes] = useState(false);
  const toggleNotes = () => setShowNotes(!showNotes);

  return <NotesContext.Provider value={{ showNotes, setShowNotes, toggleNotes }}>{children}</NotesContext.Provider>;
};
